import React from 'react';
import { motion } from 'framer-motion';
import { Filter, Trophy, Shield, Award, Globe } from 'lucide-react';

const leagues = [
  { id: 'all', name: 'Semua Liga', icon: Globe, color: 'from-gray-400 to-gray-600' },
  { id: 'premier-league', name: 'Premier League', icon: Shield, color: 'from-purple-400 to-purple-600' },
  { id: 'laliga', name: 'La Liga', icon: Trophy, color: 'from-yellow-400 to-yellow-600' },
  { id: 'serie-a', name: 'Serie A', icon: Award, color: 'from-blue-400 to-blue-600' },
  { id: 'bundesliga', name: 'Bundesliga', icon: Shield, color: 'from-red-400 to-red-600' },
  { id: 'ligue-1', name: 'Ligue 1', icon: Trophy, color: 'from-green-400 to-green-600' },
];

const LeagueFilter = ({ selectedLeague, onLeagueChange }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3 }}
      className="glass-card p-6 mb-8"
    >
      <div className="flex items-center space-x-2 mb-4">
        <Filter className="w-5 h-5 text-white/80" />
        <h2 className="text-lg font-semibold text-white">Filter Liga</h2>
      </div>
      
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
        {leagues.map((league) => {
          const Icon = league.icon;
          const isSelected = selectedLeague === league.id;
          
          return (
            <motion.button
              key={league.id}
              whileHover={{ scale: 1.05, y: -2 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => onLeagueChange(league.id)}
              className={`relative overflow-hidden p-4 rounded-xl transition-all duration-300 ${
                isSelected
                  ? `bg-gradient-to-r ${league.color} text-white shadow-lg`
                  : 'bg-white/5 hover:bg-white/10 text-white/80'
              }`}
            >
              {isSelected && (
                <motion.div
                  layoutId="selectedLeague"
                  className="absolute inset-0 bg-white/20"
                  initial={false}
                  transition={{ type: "spring", stiffness: 300, damping: 30 }}
                />
              )}
              <div className="relative z-10 flex flex-col items-center space-y-2">
                <Icon className={`w-6 h-6 ${isSelected ? 'text-white' : 'text-white/80'}`} />
                <span className="text-xs font-medium">{league.name}</span>
              </div>
            </motion.button>
          );
        })}
      </div>
    </motion.div>
  );
};

export default LeagueFilter;
